import React, { useState, useEffect } from "react";

const AdminPlot = () => {
  const [responseMessage, setResponseMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    plot_name: "",
    plot_number: "",
    price: "",
    length: "",
    breadth: "",
    total_sqfeet: "",
    category: "",
  });
  const [newCategory, setNewCategory] = useState("");
  const [showNewCategoryInput, setShowNewCategoryInput] = useState(false);

  // Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch("https://api.swalokgroup.com/api/get-categories");
        const data = await res.json();
        console.log(data);
          const filteredCategories = data
        .map((item) => item.category)
        .filter((cat) => cat && cat.trim() !== "");

        setCategories(filteredCategories);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (formData.length && formData.breadth) {
      const length = parseFloat(formData.length);
      const breadth = parseFloat(formData.breadth);
      if (!isNaN(length) && !isNaN(breadth)) {
        setFormData((prev) => ({
          ...prev,
          total_sqfeet: (length * breadth).toString(),
        }));
      }
    }
  }, [formData.length, formData.breadth]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCategory = () => {
    if (newCategory.trim()) {
      setCategories((prev) => [...prev, newCategory]);
      setFormData((prev) => ({ ...prev, category: newCategory }));
      setNewCategory("");
      setShowNewCategoryInput(false);
    }
  };

  const handleAddPlot = async (e) => {
    e.preventDefault();
    setResponseMessage("");

    try {
      const response = await fetch("https://api.swalokgroup.com/api/add-plot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setResponseMessage("Plot Added Successfully");
        setTimeout(() => setResponseMessage(""), 1000);
        setFormData({
          plot_name: "",
          plot_number: "",
          price: "",
          length: "",
          breadth: "",
          total_sqfeet: "",
          category: "",
        });
      } else {
        setResponseMessage("Failed to add plot. Try again later.");
        setTimeout(() => setResponseMessage(""), 1000);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <section className="py-5 px-4">
      <div className="sec-subheading">
        <hr />
        <span>Add Plots</span>
        <hr />
      </div>

      <div className="profile-area-inner mt-4">
        <p className="profile-heading">Add A Plot</p>

        <form className="row g-3 py-4 px-4" onSubmit={handleAddPlot}>
          {/* Plot Name */}
          <div className="col-md-4">
            <label htmlFor="plot_name" className="text-muted">
              Plot Name
            </label>
            <input
              type="text"
              className="form-input"
              name="plot_name"
              value={formData.plot_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Plot Number */}
          <div className="col-md-4">
            <label htmlFor="plot_number" className="text-muted">
              Plot Number
            </label>
            <input
              type="text"
              className="form-input"
              name="plot_number"
              value={formData.plot_number}
              onChange={handleChange}
              required
            />
          </div>

          {/* Plot Price */}
          <div className="col-md-4">
            <label htmlFor="price" className="text-muted">
              Plot Price/ Sq. Feet
            </label>
            <input
              type="text"
              className="form-input"
              name="price"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>

          {/* Plot Length */}
          <div className="col-md-4">
            <label htmlFor="length" className="text-muted">
              Plot Length
            </label>
            <input
              type="text"
              className="form-input"
              name="length"
              value={formData.length}
              onChange={handleChange}
              required
            />
          </div>

          {/* Plot Breadth */}
          <div className="col-md-4">
            <label htmlFor="breadth" className="text-muted">
              Plot Breadth
            </label>
            <input
              type="text"
              className="form-input"
              name="breadth"
              value={formData.breadth}
              onChange={handleChange}
              required
            />
          </div>

          {/* Total Sq. Feet */}
          <div className="col-md-4">
            <label htmlFor="total_sqfeet" className="text-muted">
              Total Sq. Feet
            </label>
            <input
              type="text"
              className="form-input"
              name="total_sqfeet"
              value={formData.total_sqfeet}
              onChange={handleChange}
              required
            />
          </div>

          {/* Category Dropdown */}
          <div className="col-md-4">
            <label htmlFor="category" className="text-muted">
              Category
            </label>
            <select
              className="form-input"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat, idx) => (
                <option key={idx} value={cat}>
                  {cat}
                </option>
              ))}
              <option value="_add_new">Add New Category</option>
            </select>
          </div>

          {/* Add new category input */}
          {formData.category === "_add_new" && (
            <div className="col-md-4">
              <label htmlFor="newCategory" className="text-muted">
                New Category
              </label>
              <div className="d-flex">
                <input
                  type="text"
                  className="form-input me-2"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                  placeholder="Enter new category"
                />
                <button
                  type="button"
                  className="admin-btn py-1 px-3 rounded"
                  onClick={handleAddCategory}
                >
                  Add
                </button>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="col-12 my-4 text-end">
            <button type="submit" className="admin-btn py-2 px-3 rounded">
              Submit Plot
            </button>
          </div>
        </form>

        {/* Response Message */}
        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AdminPlot;
